module.exports = "/images/laser tag (strokes).svg?86ce28deb346720ffd4136e2a07d5c76";